import React from 'react';

import s from './index.module.css';
import Button from '../Button';
import { RESET_BUTTONS } from '../../store/actions/messages';
import { useDispatch } from 'react-redux';

const QuickAnswers = ({ items, addBuyerChoice }) => {
  const dispatch = useDispatch();

  const handleBtnClick = (item) => {
    if (addBuyerChoice) {
      addBuyerChoice(item);
      dispatch({ type: RESET_BUTTONS });
    }
  };

  return (
    <div id="quick-answers" className={s.wrapper}>
      {items.map((item, i) => (
        <Button view="button" background="white" key={item.payload} onClick={() => handleBtnClick(item)}>
          {item.title}
        </Button>
      ))}
    </div>
  );
};

export default QuickAnswers;
